import { Lightning } from '@lightningjs/sdk'

import { getColor, grey50, grey800, grey920, grey960 } from '../../constants/colors'
import { getIconName } from '../../utils/cardUtils'
import { getIcon } from '../../utils/image'
import SpeechComp from '../speechComp/speechComp'
import { QwertyKey } from './utils'

const KEY_WIDTH = 70
const KEY_HEIGHT = 90

export class QwertyKeyboardKey extends SpeechComp {
  private _rowIndex: number = 0
  private _index: number = 0
  private _key: QwertyKey

  static _template() {
    return {
      w: KEY_WIDTH,
      h: KEY_HEIGHT,
      rect: true,
      color: getColor(grey800),
      flex: {
        justifyContent: 'center',
        alignItems: 'center',
      },
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: 4,
      },
      Label: {
        shaer: null,
        visible: false,
        text: {
          text: '',
          fontSize: 30,
          textColor: getColor(grey50),
          verticalAlign: 'middle',
        },
      },
      Icon: {
        color: getColor(grey50),
        texture: null,
        shader: null,
        visible: false,
      },
    }
  }

  get label() {
    return this.tag('Label')
  }

  get icon() {
    return this.tag('Icon')
  }

  set rowIndex(v: number) {
    this._rowIndex = v
  }

  get rowIndex() {
    return this._rowIndex
  }

  set index(v: number) {
    this._index = v
  }

  get index() {
    return this._index
  }

  get key() {
    return this._key
  }

  set key(v: QwertyKey) {
    this._key = v
    const { icon, label, size, disabled } = v || {}

    icon ? this.setIconKey(icon) : this.setTextKey(label)

    this.w = this.getKeySize(size)

    if (disabled) {
      this.color = getColor(grey920)
    }
  }

  get speechText(): string {
    const { label, toggle, icon } = this.key

    if (toggle) {
      return `Toggle ${toggle}`
    } else if (icon) {
      return getIconName(icon)
    } else {
      return label
    }
  }

  _focus() {
    this.focusKey(true)
    this.speak()
  }

  _unfocus() {
    this.focusKey(false)
  }

  _handleEnter() {
    this.fireAncestors('$onSoftKey', this.key)
    this.speak()
  }

  focusKey(isFocused: boolean) {
    const mainColor = isFocused
      ? getColor(grey50)
      : this.key?.disabled
      ? getColor(grey920)
      : getColor(grey800)
    const fontColor = isFocused ? getColor(grey960) : getColor(grey50)
    const scale = isFocused ? 1.05 : 1

    this.patch({
      zIndex: isFocused ? 3 : 2,
      color: mainColor,
      Label: { text: { textColor: fontColor } },
      Icon: { color: fontColor },
      smooth: { scale },
    })
  }

  getKeySize(size: string) {
    switch (size) {
      case 'md':
        return KEY_WIDTH * 2
      case 'lg':
        return KEY_WIDTH * 4
      default:
        return KEY_WIDTH
    }
  }

  setIconKey(v: string) {
    this.icon.patch({
      texture: Lightning.Tools.getSvgTexture(getIcon(v), 32, 32),
    })
    this.icon.visible = true
  }

  setTextKey(v: string) {
    this.label.patch({ text: { text: v } })
    this.label.visible = true
  }
}
